"use client";

import { styled } from "styled-components";

import {
  ptSerif_body_sm_bold,
  ptSerif_body_sm_regular,
} from "@/shared/font/pt-serif/body";

export const Wrapper = styled.div`
  position: relative;
  display: block;
  flex: 1;
  align-self: stretch;
  width: 100%;
  min-width: 0;
`;

export const TooltipContainer = styled.div<{
  $position: "left" | "right";
  $maxWidth: string;
  $sameWidthAsText?: boolean;
}>`
  position: absolute;
  top: calc(100% + 0.4rem);
  ${({ $position }) => ($position === "left" ? "left: 0;" : "right: 0;")}
  width: ${({ $sameWidthAsText }) =>
    $sameWidthAsText ? "100%" : "max-content"};
  max-width: ${({ $sameWidthAsText, $maxWidth }) =>
    $sameWidthAsText ? "100%" : $maxWidth};
  z-index: 1000;
`;

export const TooltipBase = styled.div`
  display: flex;
  padding: var(--Spacing-4, 0.4rem) var(--Spacing-8, 0.8rem)
    var(--Spacing-4, 0.4rem) var(--Spacing-4, 0.4rem);
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--Spacing-8, 0.8rem);

  border-radius: var(--Border-Radius-4, 0.4rem);
  border: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
  background: var(--Color-Common-Bg-Primary, #fff);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16),
    0px 0px 2px 0px rgba(0, 0, 0, 0.12);

  color: var(--Color-Common-Text-Primary, #2a2f37);
  ${ptSerif_body_sm_regular}
`;

export const TooltipClamp = styled.div<{ $isBold?: boolean }>`
  ${({ $isBold }) => ($isBold ? ptSerif_body_sm_bold : ptSerif_body_sm_regular)}
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 10;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
`;
